import axios from "axios";
// Detecta ambiente automaticamente
var isDev = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
// Altere conforme necessário para seu backend
var API_BASE_URL = isDev
    ? "http://localhost:8000/api" // Django local
    : "https://www.visioncockpit.com.br/api"; // Produção
var api = axios.create({
    baseURL: API_BASE_URL,
    timeout: 600000,
    withCredentials: false,
});
// Helper para redirecionar sem loop
function redirectToConnectionError(reason) {
    var loginPath = "/login";
    var errorPath = "/erro-conexao";
    var here = window.location.pathname;
    if (here.startsWith(loginPath) || here.startsWith(errorPath))
        return; // evita loop
    // guarda info para a tela de erro
    try {
        sessionStorage.setItem("lastApiError", JSON.stringify({
            reason: reason,
            time: new Date().toISOString(),
            from: here + window.location.search
        }));
    }
    catch (_a) { }
    window.location.href = "".concat(errorPath, "?from=").concat(encodeURIComponent(here + window.location.search));
}
api.interceptors.response.use(function (response) { return response; }, function (error) {
    var _a, _b, _c, _d, _e;
    var status = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status;
    // 401 -> login (mantém comportamento atual)
    if (status === 401) {
        try {
            localStorage.removeItem("authToken");
        }
        catch (e) { }
        try {
            localStorage.clear();
        }
        catch (e) { }
        try {
            sessionStorage.clear();
        }
        catch (e) { }
        var loginPath = "/login";
        if (!window.location.pathname.startsWith(loginPath)) {
            window.location.href = loginPath;
        }
        return Promise.reject(error);
    }
    // 403 com mensagem específica de agência -> redireciona para criar agência
    if (status === 403) {
        var errorMessage = ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.error) || ((_e = (_d = error === null || error === void 0 ? void 0 : error.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.detail) || "";
        // Verifica se o erro é relacionado à falta de agência
        var isAgencyError = /não está associado a uma agência/i.test(errorMessage) ||
            /usuário não possui agência/i.test(errorMessage) ||
            /agency not found/i.test(errorMessage) ||
            /no agency/i.test(errorMessage);
        if (isAgencyError) {
            var agencySelectPath = "/agency/select";
            var loginPath = "/login";
            var registerPath = "/register";
            var currentPath = window.location.pathname;
            // Evita loop: não redireciona se já está em uma dessas páginas
            if (!currentPath.startsWith(agencySelectPath) &&
                !currentPath.startsWith(loginPath) &&
                !currentPath.startsWith(registerPath)) {
                console.warn("Usuário sem agência detectado. Redirecionando para criar agência...");
                window.location.href = agencySelectPath;
                return Promise.reject(error);
            }
        }
    }
    return Promise.reject(error);
});
export default api;
